import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@fiverr-private/fit';
import { ArrowRightIcon, WandIcon } from '@fiverr-private/visuals';

const iconMapper = {
    'styled-list-item': {
        IconComponent: ArrowRightIcon,
        color: '#7a7d85',
        size: 12,
    },
    'spotlight-item': {
        IconComponent: WandIcon,
        color: '#4a73e8',
        size: 14,
    },
};

const ItemIcon = ({ style }) => {
    const icon = iconMapper[style];

    if (!icon) {
        return null;
    }
    const { color, size, IconComponent } = icon;

    return (
        <Icon className="categories-icon" color={color} size={size}>
            <IconComponent />
        </Icon>
    );
};

ItemIcon.propTypes = {
    style: PropTypes.string,
};

export default ItemIcon;
